import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import {
  enableProdMode,
  NgModule,
  ReflectiveInjector,
  Injector,
} from "@angular/core";
import { environment } from "./environments/environment";
import { AppModule } from "./app/app.module";
import { AppConfigSettings } from "@arc/arc-shared-frontend";

fetch('/assets/app.settings.json').then(res => res.json()).then((r: any) => {
  const configSetting = new AppConfigSettings();
  if (r) {
    r.forEach(element => {
      for (const key in element) {
        if (element.hasOwnProperty(key)) {
          configSetting.settings.set(key, element[key]);
        }
      }
    });
    platformBrowserDynamic([{ provide: AppConfigSettings, useValue: configSetting }]).bootstrapModule(AppModule);
  }
});

// const configSetting = new AppConfigSettings();
// if (appsettings && appsettings.length > 0) {
//   appsettings.forEach((element) => {
//     for (const key in element) {
//       if (element.hasOwnProperty(key)) {
//         configSetting.settings.set(key, element[key]);
//       }
//     }
//   });
// }
// if (configSetting.getconfig("appMode") === "prod") {
//   enableProdMode();
// }
// platformBrowserDynamic([
//   { provide: AppConfigSettings, useValue: configSetting },
// ]).bootstrapModule(AppModule);

// const httpClientInjector1 = Injector.create([
//   { provide: HttpClient, deps: [HttpHandler] },
//   { provide: HttpHandler, useClass: HttpXhrBackend, deps: [XhrFactory] },
//   { provide: XhrFactory, useClass: ɵangular_packages_common_http_http_d, deps: [] }
// ]);

if (environment.production) {
  enableProdMode();
}

// const http = httpClientInjector1.get(HttpClient);

// http.get('/assets/app.settings.json').subscribe((r: any) => {
//   const configSetting = new AppConfigSettings();
//   if (r && r.length > 0) {
//     r.forEach(element => {
//       for (const key in element) {
//         if (element.hasOwnProperty(key)) {
//           configSetting.settings.set(key, element[key]);
//         }
//       }
//     });
//   }
//   if (configSetting.getconfig('appMode') === 'prod') {
//     enableProdMode();
//   }
//   platformBrowserDynamic([{ provide: AppConfigSettings, useValue: configSetting }]).bootstrapModule(AppModule);
// });

// platformBrowserDynamic([{ provide: AppConfigSettings, useValue: configSetting }]).bootstrapModule(AppModule);

// fetch('/assets/app.settings.json').then(res => res.json()).then((r: any) => {
//   const configSetting = new AppConfigSettings();
//   if (r) {
//     r.forEach(element => {
//       for (const key in element) {
//         if (element.hasOwnProperty(key)) {
//           configSetting.settings.set(key, element[key]);
//         }
//       }
//     });
//     platformBrowserDynamic([{ provide: AppConfigSettings, useValue: configSetting }]).bootstrapModule(AppModule);
//   }
// });
